export default "/images/7fa053c4b0f20302b0099390f01be1e3.avif";